import { Grid } from "@mui/material";
import axios from "axios";
import React from "react";
import Swal from "sweetalert2";
import Styles from "./Styles/moduleLayout.module.css";
import { encrypt } from "../../utils/cipher";
import { useNavigate } from "react-router-dom";
import { ls } from "../../variables";
import { errorHandler } from "../../utils/errorHandling";
import { alert } from "../../utils/sweetAlert";
const CommentComponent = (props) => {
  const navigate = useNavigate();


  const handleDownload = async (id, array) => {
    let filePath = array[id].s3Location;
    let folder = "ALERT";
    if (filePath == undefined) {
      alert("Sorry!!", "No File Found", "error")
      return;
    }
    const payload = {
      s3Location: filePath,
      moduleType: folder,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken"),
    };
    const encryptedPayload = await encrypt(payload);

    axios
      .post(
        "/api/pms/downloadReport",
        { payload: encryptedPayload },
        {
          withCredentials: true,
        }
      )
      .then((val) => {
        window.open(val.data.data, "_self");
      })
      .catch((err) => {
        errorHandler(err, navigate)
      });
  };

  return (
    <Grid
      container
      style={{
        backgroundImage: props.rowStatus == "closed" ? "linear-gradient(#D9D9D9, #D9D9D9)" : "linear-gradient(#d4e4f2,#f0f0f0)",

        boxShadow: " 0 2px 4px 0 rgba(0, 0, 0, 0.2) ",
        padding: "0.5rem",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        marginTop: "0.5rem",
        width: "100%",
        borderRadius: "1rem",
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "5.7rem",
          paddingBottom: "0.8rem"
        }}
      >
        <p
          style={{
            fontWeight: "bold",
            color: "#154063",
            margin: 0,
            fontSize: "0.8rem"
          }}
        >
          {props.date}
        </p>
        <p style={{
          fontWeight: "bold",
          color: "#154063",
          margin: 0,
          fontSize: "0.8rem"
        }}>
          Case ID Count: {props.instanceCount}
        </p>
      </Grid>
      {props.pmsComment != undefined || props.rtaComment  != undefined ? (
        <>
          <Grid
            item
            xs={4}
            sm={2}
            md={1.5}
            style={{
              display: "flex",
              alignItems: "center",
              // justifyContent: "center",
            }}
          >
            <p
              style={{
                fontWeight: "bold",
                color: "#154063",

              }}
            >
              {props.pmsComment != undefined ? "PMS Comments" : "RTA Comments"}
            </p>
          </Grid>
          <Grid
            item
            xs={8}
            sm={4}
            md={3.5}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "90%",
                borderRadius: "0.5rem",
                border: "0px",
                backgroundColor: "#FFFFFF",
                resize: "none",
                overflowY: "auto",
                padding: "5px",
                minHeight: "2rem",
                maxHeight: "10rem",
                whiteSpace: "pre-wrap"
              }}
            >
              {props.pmsComment != undefined ? props.pmsComment.length > 0 ? props.pmsComment : "NA" : props.rtaComment.length > 0 ? props.rtaComment : "NA"}
            </div>
          </Grid>

          <Grid item xs={4} sm={2} md={1.5} style={{ display: "flex", alignItems: "center", justifyContent: "center", }}>
            <p style={{ fontWeight: "bold", color: "#154063", }}>
              Proposed Plan of Action
            </p>
          </Grid>
          <Grid
            item
            xs={8}
            sm={4}
            md={3.5}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "90%",
                borderRadius: "0.5rem ",
                border: "0px",
                backgroundColor: "#FFFFFF",
                resize: "none",
                overflowY: "auto",
                padding: "5px",
                minHeight: "2rem",
                maxHeight: "10rem",
                whiteSpace: "pre-wrap"
              }}
            >
              {props.ppaComment.length > 0 ? props.ppaComment : "NA"}
            </div>
          </Grid>
        </>
      ) : (
        props.sebiComment !=undefined  &&  <>
        <Grid item xs={4} sm={2} md={1.5} lg={1.5} style={{ display: "flex", alignItems: "center" }}>
            <p style={{ fontWeight: "bold", color: "#154063" }}>
              SEBI Comments
            </p>
          </Grid>
          <Grid item xs={8} sm={10} md={10.5} lg={8.5} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div
              style={{
                width: "96%",
                borderRadius: "0.5rem ",
                border: "0px",
                backgroundColor: "#FFFFFF",
                resize: "none",
                overflowY: "auto",
                padding: "5px",
                minHeight: "2rem",
                maxHeight: "10rem",
                whiteSpace: "pre-wrap"
              }}
            >
              {props?.sebiComment?.length > 0 ? props?.sebiComment : "NA"}
            </div>
          </Grid>
          </>
            
      )}

      <Grid
        item
        md={2}
        style={{ display: "flex", justifyContent: "space-evenly" }}
      >
        <button
          className={Styles.Preview}
          onClick={() => handleDownload(props.index, props.remarksArray)}
          style={{
            backgroundColor:
              (props.remarksArray[props.index].s3Location == undefined || props.remarksArray[props.index].s3Location == "")
                ? "#808080"
                : "#154063",
            cursor:
              props.remarksArray[props.index].s3Location == undefined
                ? "initial"
                : "pointer",
            border: props.remarksArray[props.index].s3Location == undefined
              ? "0.125rem solid #808080" : "0.125rem solid #154063",
          }}
          disabled={
            props.remarksArray[props.index].s3Location == undefined || props.remarksArray[props.index].s3Location == ""
              ? true
              : false
          }
        >
          DOWNLOAD
        </button>
      </Grid>
    </Grid>
  );
};

export default CommentComponent;
